import {
  FETCH_SCORING_CONFIG,
  FETCH_SCORING_CONFIG_SUCCESS,
  FETCH_SCORING_CONFIG_FAIL,
  SAVE_SCORING_CONFIG,
  SAVE_SCORING_CONFIG_SUCCESS,
  SAVE_SCORING_CONFIG_FAIL,
  RESET_SCORING_CONFIG,
  RESET_SCORING_CONFIG_SUCCESS,
  RESET_SCORING_CONFIG_FAIL,
  SCORING_CONFIG_CLEAR
} from '../../actions/trm/scoringConfig';

const initialState = {
  data: null,
  loading: false,
  saving: false,
  error: null,
  lastSavedAt: null
};

export default function scoringConfig(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SCORING_CONFIG:
      return { ...state, loading: true, error: null };
    case FETCH_SCORING_CONFIG_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_SCORING_CONFIG_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SAVE_SCORING_CONFIG:
      return { ...state, saving: true, error: null };
    case SAVE_SCORING_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload,
        lastSavedAt: Date.now()
      };
    case SAVE_SCORING_CONFIG_FAIL:
      return { ...state, saving: false, error: action.payload };
    case RESET_SCORING_CONFIG:
      return { ...state, saving: true, error: null };
    case RESET_SCORING_CONFIG_SUCCESS:
      return { ...state, saving: false, data: null, lastSavedAt: Date.now() };
    case RESET_SCORING_CONFIG_FAIL:
      return { ...state, saving: false, error: action.payload };
    case SCORING_CONFIG_CLEAR:
      return initialState;
    default:
      return state;
  }
}
